import styled, { css } from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

import { LegacyDropdownPlacement } from './LegacyDropdownTypes';

const menuListPlacementStyles = {
  up: css`
    display: flex;
    flex-direction: column-reverse;
  `,
  right: css`
    display: flex;
    flex-direction: row;
  `,
  left: css`
    display: flex;
    flex-direction: row-reverse;
  `,
  down: ``,
};

export const LegacyDropdownMenuList = styled.div<{
  $desktopPlacement: LegacyDropdownPlacement;
  $mobilePlacement: LegacyDropdownPlacement;
}>`
  ${(props) => menuListPlacementStyles[props.$desktopPlacement]};

  @media all and (max-width: ${cssBreakpoints.mdUp}) {
    ${(props) => menuListPlacementStyles[props.$mobilePlacement]}
  }
`;

const menuContainerPlacementStyles = {
  up: css`
    bottom: 0;
    left: unset;
    right: 0;
    top: unset;
  `,
  left: css`
    top: 0;
    right: -20px;
    left: unset;
  `,
  down: css`
    top: 0;
  `,
  right: css`
    top: 0;
  `,
};
const menuContainerMobilePlacementStyles = {
  ...menuContainerPlacementStyles,
  up: css`
    bottom: 0;
    left: unset;
    right: 0;
    top: unset;
  `,
  right: css`
    top: 15px;
  `,
  left: css`
    top: 15px;
    right: -20px;
    left: unset;
  `,
};

export const LegacyDropdownMenuContainer = styled.div<{
  $desktopPlacement: LegacyDropdownPlacement;
  $mobilePlacement: LegacyDropdownPlacement;
  $open?: boolean;
  $marginLeft?: number;
}>`
  position: absolute;
  left: 0;
  z-index: 2000;
  overflow: hidden;
  transition: all 0.166s;
  opacity: ${(props) => (props.$open ? undefined : 0)};
  visibility: ${(props) => (props.$open ? undefined : 'hidden')};
  margin-left: ${(props) =>
    props.$marginLeft ? `${props.$marginLeft}px` : undefined};

  ${(props) => menuContainerPlacementStyles[props.$desktopPlacement]};

  @media all and (max-width: ${cssBreakpoints.mdUp}) {
    ${(props) => menuContainerMobilePlacementStyles[props.$mobilePlacement]}
  }
`;

export const LegacyDropdownTriggerContainer = styled.div<{
  $noPadding?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${(props) => (props.$noPadding ? '0' : '11px 12px 0')};
`;

export const LegacyDropdownContainer = styled.div`
  position: relative;
`;

const itemsContainerPlacementStyles = {
  left: css`
    margin-left: 0;
    margin-top: 5px;
  `,
  right: css`
    margin-left: 0;
    margin-top: 5px;
  `,
  up: css`
    margin-left: 10px;
  `,
  down: css`
    margin-left: 10px;
  `,
};

export const LegacyDropdownItemsContainer = styled.div<{
  $unstyled?: boolean;
  $desktopPlacement: LegacyDropdownPlacement;
  $mobilePlacement: LegacyDropdownPlacement;
}>`
  ${(props) =>
    !props.$unstyled &&
    css`
      background-color: white;
      border-radius: 8px;
      border: 1px solid #ebeced;
    `}
  ${(props) => itemsContainerPlacementStyles[props.$desktopPlacement]};

  @media all and (max-width: ${cssBreakpoints.mdUp}) {
    ${(props) => itemsContainerPlacementStyles[props.$mobilePlacement]}
  }
`;
